import { useEffect } from 'react';
import { Wootric } from '../types';

export function useWootricDebug({ debug }: Wootric.Debug.Props) {
  useEffect(() => {
    if (!debug) return;
    const script = document.createElement('script');
    script.id = 'wootric-debug';
    script.type = 'text/javascript';
    script.innerHTML = `
              wootric_survey_immediately=true; //Overwrites sampling settings and forces the server to return true to all survey requests.
              wootric_no_surveyed_cookie = true; //Disables the cookie that tracks if a user has been surveyed before.
            `;
    document.body.appendChild(script);
    return () => script.remove();
  }, [debug]);
}
